// extracted by mini-css-extract-plugin
export default {"mainPage":"IndexPage_mainPage__h4qy6","bodyStudioDescription":"IndexPage_bodyStudioDescription__cZR1E","logo":"IndexPage_logo__mY9+L"};